export enum AnswerType {
  PLAIN = 'plain',
  DETAIL = 'detail',
  CARD = 'card',
  EMOJI = 'emoji'
}